import { ingestAPIObject } from "../utils/api";
import { centerOfMass, distance, pointToPolygonDistance } from "@turf/turf";
export class LotDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
    }
    distanceTo(point) {
        if (!this.boundary || !Number.isFinite(point[0]))
            return undefined;
        const roughDistance = distance(centerOfMass(this.boundary).geometry.coordinates, point);
        // If we're far away, just use the dist from the center
        if (roughDistance > 5) {
            return roughDistance;
        }
        return Math.max(0, pointToPolygonDistance(point, this.boundary));
    }
    get fullName() {
        return this.ranchId ? `${this.ranchName} - ${this.name}` : this.name;
    }
}
